import { Box } from '@bpba/ui-components';
import { FC } from 'react';
import { ReactComponent as MesumoLogo } from '../../assets/icons/logo.svg';
import styled from 'styled-components';

type Props = {
  color: string;
  linkUrl?: string;
  altText?: string;
};

export const Logo: FC<Props> = ({ linkUrl, altText, color }) => {
  return (
    <a href={linkUrl} aria-label={altText}>
      <Box width={['70px', '120px', '148px']}>
        <MesumoLogoStyled width={'100%'} fill={color} />
      </Box>
    </a>
  );
};

type MesumoLogoStyledProps = {
  fill: string;
};

const MesumoLogoStyled = styled(MesumoLogo)<MesumoLogoStyledProps>(({ fill }) => ({
  fill: fill,
}));
